import React, { Component } from 'react';
import {webshop,searchkit} from './webshop';
import {SearchkitProvider,
  HitsStats, SortingSelector, NoHits,
  RangeAccessor, RangeFilter, Hits, Panel, InputFilter, CheckboxItemList,
  Layout, LayoutBody, LayoutResults, InitialLoader,
  SideBar, Pagination} from 'searchkit';
import PerPageSelector from './PerPageSelector';
import HitsGridItem from './HitsGridItem';
import CustomHitStats from './HitsStats';
import CustomRangeComponent from './RangeComponent';
import InlineList from './InlineList';
import SearchBox from './SearchBox';
import FacetFilter from './FacetFilter';
import './index.css';
import lodash from 'lodash';

const MOBILE = 768;

const InitialLoaderComponent = (props) => (
  <div className="ws-loader">loading please wait...</div>
);

class App extends Component {

  constructor(props) {
    super(props)

    this.onPriceReset = this.onPriceReset.bind(this)
    this.onPriceUpdate = this.onPriceUpdate.bind(this)

    this.state = {
      current: null,
      sidebar: false,
      min: webshop.minPrice,
      max: webshop.maxPrice
    };
  }

  onPriceReset() {
    this.onPriceUpdate({
      min: webshop.minPrice,
      max: webshop.maxPrice
    });
  }

  onPriceUpdate(values) {
    const accessor = searchkit.accessors.getAccessorByType(RangeAccessor);
    let min = Number(values.min);
    let max = Number(values.max);

    if (min === max) {
      min = webshop.minPrice;
      max = webshop.maxPrice;
    }

    accessor.options.min = min;
    accessor.options.max = max;
    accessor.state = accessor.state.setValue({
      min: min,
      max: max
    });

    this.setState(values);
    this.forceUpdate();
    searchkit.performSearch();
  }

  onScroll() {
    if (window.scrollY > 1000) {
      this.element.classList.add('sk-scroll-top-visible');
    } else {
      this.element.classList.remove('sk-scroll-top-visible');
    }
  }

  onResize(ev) {
    if (window.innerWidth < MOBILE && this.state.sidebar) {
      this.sidebarElement.classList.add('ws-sidebar-fixed');
    } else {
      this.sidebarElement.classList.remove('ws-sidebar-fixed');
    }
  }

  componentDidMount() {
    this.element = document.querySelector('.sk-scroll-top');
    this.sidebarElement = document.querySelector('.ws-sidebar');

    const scroll = () => {
      window.scrollTo(0, window.scrollY - 50);
      if (window.scrollY > 0) {
        window.requestAnimationFrame(scroll);
      }
    };

    this.element.addEventListener('click', () => {
      window.requestAnimationFrame(scroll);
    });

    window.addEventListener('scroll', this.onScroll.bind(this))
    window.addEventListener('resize', this.onResize.bind(this))
  }

  closePanels() {
    const elements = document.querySelectorAll('.ws-hit');
    lodash.forEach(elements, (i) => i.classList.remove('ws-hit-active'));
  }

  onClick(id) {
    if (typeof id === "string") {
      this.closePanels();
      if (this.state.current === id) {
        this.setState({ current: null });
      } else {
        this.setState({ current: id });
      }
    }
  }

  onFilterToggle(ev) {
    ev.preventDefault();
    document.body.classList.add('ws-sidebar-open');
    this.setState({ sidebar: true });
  }

  onCloseSidebar(ev) {
    ev.preventDefault();
    document.body.classList.remove('ws-sidebar-open');
    this.setState({ sidebar: false });
  }

  onClose(id) {
    this.closePanels();
    this.setState({ current: null });
  }

  render() {
    let domain;
    let sidebarClassName = "";

    if (this.state.sidebar) {
      sidebarClassName = "ws-sidebar-fixed";
    }

    if (webshop.query && webshop.domain) {
      domain = (<div className="ws-domain">
        <span className="ws-domain-query">{webshop.query}</span>
        <span className="ws-domain-text">.{webshop.domain}</span>
      </div>);
    }

    return (
      <SearchkitProvider searchkit={searchkit}>
        <Layout className="container">
          <div className="sk-header row">
            <div className="col-lg-2 sk-logo">
              <a href="/" className="sk-logo__icon">Webshop.nl</a>
              <div className="sk-close hidden-lg-up">
                <div className="sk-close__icon">&times;</div>
              </div>
            </div>
            <div className="col-lg-8 sk-search">
              <SearchBox
                autofocus={true}
                searchOnChange={true}
                searchThrottleTime={2}
                placeholder={webshop.lang.searchPlaceholder}
                buttonLabel={webshop.lang.search}
                queryFields={["name", "description", "category", "subcategory", "brand"]}
              />
            </div>
            <div className="col-lg-2 sk-close hidden-md-down">
              <div className="sk-close__icon">&times;</div>
            </div>
          </div>
          <LayoutBody>
            <div className="row">
              <div className="col-6 hidden-lg-up sk-filter-toggle" onClick={this.onFilterToggle.bind(this)}>
                <span className="sk-filter-toggle__icon"></span>
                <span className="sk-filter-toggle__text">Filter</span>
              </div>
              <div className="col-6 sk-page-stats hidden-lg-up">
                 <HitsStats component={CustomHitStats}/>
              </div>
              <div className="col-xl-2 col-lg-3 col-sm-4 hidden-md-down">
                <HitsStats
                  translations={{ "hitstats.results_found":"{hitCount} " + webshop.lang.count }}
                />
              </div>
              <div className="col-xl-6 col-lg-5 col-md-4 col-sm-6 col-sm-4 hidden-md-down">
                <SortingSelector
                  listComponent={InlineList}
                  showCount="false"
                  className="ws-sorter"
                  options={[
                    {label: "Popular", field: "_score", order: "desc"},
                    {label: "Price lowest", field: "price", order: "desc"},
                    {label: "Price highest", field: "price", order: "asc"},
                    {label: "New", field: "timestamp", order: "desc"},
                  ]}
                  translations={{
                    "Popular" : webshop.lang.sortPopular, 
                    "New" : webshop.lang.sortNew,
                    "Price lowest": webshop.lang.sortPrice,
                    "Price highest": webshop.lang.sortPrice
                  }}
                />
              </div>
              <div className="sk-page-size col-xl-4 col-lg-4 col-md-4 col-sm-4 hidden-md-down">
                <PerPageSelector
                  options={[24, 48, 96, 192]}
                  label={webshop.lang.perPage}
                  className="sk-select-wide"
                />
              </div>
            </div>
            <div className="row">
              <div className={"col-xl-2 col-lg-3 ws-sidebar " + sidebarClassName}>
                <div className="ws-sidebar-inner">
                  <div className="ws-sidebar-header hidden-lg-up">
                    <div className="ws-sidebar-title">Filter</div>
                    <div className="ws-sidebar-close sk-close" onClick={this.onCloseSidebar.bind(this)}>
                      <span className="sk-close__icon"></span>
                    </div>
                  </div>

                  <SideBar>
                    <Panel className="sk-panel ws-sorter hidden-lg-up" collapsable={true} defaultCollapsed={false} title={webshop.lang.sidebarSortLabel}>
                      <SortingSelector
                        listComponent={CheckboxItemList}
                        showCount="false"
                        options={[
                          {label: "Popular", field: "_score", order: "desc"},
                          {label: "New", field: "timestamp", order: "desc"},
                          {label: "Price lowest", field: "price", order: "desc"},
                          {label: "Price highest", field: "price", order: "asc"}
                        ]}
                        translations={{
                          "Popular" : webshop.lang.sortPopular, 
                          "Price lowest": webshop.lang.sortPriceLowest,
                          "Price highest": webshop.lang.sortPriceHighest,
                          "New" : webshop.lang.sortNew
                        }}
                      />
                    </Panel>
                    <FacetFilter id="categorie" title={webshop.lang.category} field="category.raw" size={webshop.filterLimit} operator="OR"
                      translations={{
                        "facets.view_more": webshop.lang.more,
                        "facets.view_less": webshop.lang.less,
                        "facets.view_all": webshop.lang.all
                      }}
                      containerComponent={<Panel collapsable={true} defaultCollapsed={false}/>}
                    />
                    <FacetFilter id="campaign" title={webshop.lang.shop} field="campaign.raw" size={webshop.filterLimit} operator="OR"
                      translations={{
                        "facets.view_more": webshop.lang.more,
                        "facets.view_less": webshop.lang.less,
                        "facets.view_all": webshop.lang.all
                      }}
                      containerComponent={<Panel collapsable={true} defaultCollapsed={false}/>}
                    />
                    <Panel collapsable={true} defaultCollapsed={false} title={webshop.lang.brand}>
                      <InputFilter
                        id="brand_q"
                        placeholder={webshop.lang.brandSearchPlaceholder}
                        searchOnChange={true}
                        title={webshop.lang.brand} 
                        prefixQueryFields={["brand.raw^4"]}
                        containerComponent={<div />}
                      />
                      <FacetFilter id="brand" title="" field="brand.raw" size={webshop.filterLimit} operator="OR"
                        translations={{
                          "facets.view_more": webshop.lang.more,
                          "facets.view_less": webshop.lang.less,
                          "facets.view_all": webshop.lang.all
                        }}
                        containerComponent={<div/>}
                      />
                    </Panel>
                    <RangeFilter min={this.state.min} max={this.state.max} field="price" id="price" title={webshop.lang.price} 
                      showHistogram={true}
                      showInput={true}
                      containerComponent={<Panel collapsable={true} defaultCollapsed={false}/>}
                      rangeComponent={<CustomRangeComponent currency={webshop.currency} onReset={this.onPriceReset} onUpdate={this.onPriceUpdate}/>}
                      rangeFormatter={(m) => webshop.currency + m}
                    />
                  </SideBar>

                  <div className="ws-sidebar-footer hidden-lg-up">
                    <button type="button" className="btn btn-primary btn-lg btn-block ws-sidebar-more-results" onClick={this.onCloseSidebar.bind(this)}>{webshop.lang.moreResults}</button>
                  </div>
                </div>
              </div>

              <LayoutResults className="col-xl-10 col-lg-9 col-sm-12">
                  {domain}
                  <Hits
                    hitsPerPage={24}
                    highlightFields={["name","description"]}
                    sourceFilter={["id", "description", "name", "images", "thumbs", "timestamp", "category", "url", "discount", "campaign", "campaignImage", "currency", "brand", "price", "subcategory"]}
                    itemComponent={<HitsGridItem lang={webshop.lang} currency={webshop.currency} current={this.state.current} onClick={this.onClick.bind(this)} onClose={this.onClose.bind(this)}/>}
                    className="row"
                    scrollTo="body"
                    translations={{
                      "currency": "EUR",
                    }}
                  />
                  <NoHits suggestionsField={"name"} translations={{
                    "NoHits.NoResultsFound": webshop.lang.noResultsFound,
                    "NoHits.Error": webshop.lang.resultError,
                    "NoHits.ResetSearch": webshop.lang.resultReset
                  }}/>
                  <Pagination showNumbers={true} pageScope={webshop.pageWindow} showLast={true} className="pagination"/>
                </LayoutResults>
              </div>
              
              <div className="sk-scroll-top"></div>
            </LayoutBody>
            <div className="row">
              <div className="sk-footer col-12">
                <p className="sk-footer__text" dangerouslySetInnerHTML={{__html:webshop.lang.copyright}}></p>
              </div>
            </div>
            <InitialLoader component={InitialLoaderComponent}/>
        </Layout>
      </SearchkitProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js